import styled from 'styled-components'
import { Box, TextArea } from "@usap/uicomponents"

const darkColor = (props) => props.theme.global.colors['dark-2']

export const CommentBoxContainer = styled(Box)`
  margin-bottom: 24px;
`

export const CommentTextArea = styled(TextArea)`
  font-size: 16px;
  font-weight: 400;
  resize: none;
  border: 1px solid #ADADAD;
  border-radius: 4px;
  padding: 10px 16px;
  color: ${darkColor};

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }

  ::placeholder {
    color: #858585;
  }
`
